import { MdDownload } from 'react-icons/md';
import * as s from '../style';
import IconType from '../type';

export const IconJSX = ({
  title,
  color,
  onClick,
  style,
  className,
  size,
  disabled = false,
}: IconType): JSX.Element => (
  <s.IconContainer
    style={{ marginTop: '1px', ...style }}
    onClick={disabled ? () => null : onClick}
    title={title}
    className={`icon ${className}`}
    disabled={disabled}
    size={size}
  >
    <MdDownload fill={color} />
  </s.IconContainer>
);

export default IconJSX;
